export default __webpack_public_path__ + "f6dbf9a7d281fc0da2653c06bc951d48.png";